import { Calendar, Lock, Check, ChevronDown } from "lucide-react";
import { useProgramYear } from "@/contexts/ProgramYearContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/**
 * Top-bar performance-year selector. Switches the per-user VIEWING year, which
 * drives every data screen. Past (locked) years are still viewable (read-only).
 */
export function YearSelector() {
  const {
    programYear,
    operatingYear,
    availableYears,
    setViewingYear,
    isYearLocked,
    isCurrentYearLocked,
    loading,
  } = useProgramYear();

  if (loading) {
    return (
      <div className="flex items-center gap-1.5 text-sm text-muted-foreground whitespace-nowrap">
        <Calendar className="h-4 w-4" />
        <span>Program Year: …</span>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground whitespace-nowrap focus:outline-none"
          aria-label="Change viewing year"
        >
          <Calendar className="h-4 w-4" />
          <span>Program Year: {programYear}</span>
          {isCurrentYearLocked && <Lock className="h-3.5 w-3.5 text-amber-600" />}
          <ChevronDown className="h-3.5 w-3.5 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        <DropdownMenuLabel>View performance year</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {availableYears.map((y) => (
          <DropdownMenuItem
            key={y}
            onClick={() => setViewingYear(y)}
            className="flex items-center gap-2"
          >
            <span className="flex-1">
              {y}
              {y === operatingYear && (
                <span className="ml-1 text-xs text-muted-foreground">· current</span>
              )}
            </span>
            {isYearLocked(y) && <Lock className="h-3.5 w-3.5 text-amber-600" />}
            {y === programYear && <Check className="h-3.5 w-3.5" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
